import React from 'react';
import { Link } from 'react-router-dom';

import { Direction } from '@prisjakt/ui';
import { ButtonIcon } from '@prisjakt/ui/button';
import { IconCompare } from '@prisjakt/ui/icon';
import { useAppContext } from '@prisjakt/ui-app-context';

import { ProductPageQuery } from 'src/types';

import { ButtonText, Tooltip, Button } from './styles';

export const CompareButton: React.VFC<CompareButtonProps> = ({ product }) => {
  const { t, linkTo } = useAppContext();
  const linkProps = {
    to: linkTo('productCompare', {
      category: product.category,
      products: [product],
    }),
    rel: 'nofollow',
  };
  return (
    <Tooltip
      title={t('product', 'action-button.compare-tooltip')}
      width={180}
      placement={Direction.Down}
    >
      <Button
        ariaLabel={t('product', 'product-compare.compare')}
        container={Link}
        containerProps={linkProps}
      >
        <ButtonIcon>
          <IconCompare />
        </ButtonIcon>
        <ButtonText>{t('product', 'product-compare.compare')}</ButtonText>
      </Button>
    </Tooltip>
  );
};

interface CompareButtonProps {
  product: NonNullable<ProductPageQuery['product']>;
}
